import TutorialPost from './tutorialPost'

export default TutorialPost



// WEBPACK FOOTER //
// ./client/pages/home/tutorialPost/index.tsx